import publicKey from '../configs/_rsa_public_key';
import { JSEncrypt } from 'jsencrypt';

export const asymmetricEncrypt = (data) => {
      const Encrypt = new JSEncrypt();
      Encrypt.setPublicKey(publicKey);
      
      return Encrypt.encrypt(data);
}